import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Hero from './components/Hero.jsx';
import Header from './components/Header/Header.jsx';
import Footer from './components/Footer/Footer.jsx';
import DetailBodios from './components/MenuDetail/DetailBodios.jsx';
import About from './components/About/AboutUs.jsx';
import YakDetail from './components/YaKDetail/YakDetail.jsx';
import Social from './components/Social/Social.jsx';
import { CollectionPage } from './components/Category/CollectionPage.jsx';
import { BrandStory } from './components/Core/BrandStory.jsx';
import { Artisan } from './components/Artisan/Artisan.jsx';
import BoutiqueHeader from './components/BoutiqueHeader/BoutiqueHeader.jsx';
import { ImageGallery } from './components/Three/ImageGallery.jsx';
import JournalLayout from './components/Journal/JournalLayout.jsx';
import { ProductDetailPage } from "./components/Category/ProductDetailPage.jsx";
import CartPage from './components/Cart/CartPage.jsx';
import CheckoutPage from './components/Cart/CheckoutPage.jsx';
import SuccessPage from "./components/Cart/SuccessPage";
import { CartProvider } from './context/CartContext';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import YakTrekSection from './components/YakTrekSection.jsx';

function App() {
  return (
    <Router>
      <CartProvider>
        <div className="App">
          <Routes>
            {/* Home - transparent header */}
            <Route path="/" element={
              <>
                <Header />
                <Hero />
                <BoutiqueHeader />
                <YakTrekSection />
                <ImageGallery />
                <Artisan />
                <BrandStory />
              </>
            } />
            
            {/* Other pages - white header */}
            <Route path="/bodios" element={<><Header variant="white" /><DetailBodios /></>} />
            <Route path="/journal" element={<><Header variant="white" /><JournalLayout /></>} />
            <Route path="/about" element={<><Header variant="white" /><About /></>} />
            <Route path="/yak" element={<><Header variant="white" /><YakDetail /></>} />
            <Route path="/social" element={<><Header variant="white" /><Social /></>} />
            <Route path="/category/:category" element={<><Header variant="white" /><CollectionPage /></>} />
            <Route path="/product/:productId" element={<><Header variant="white" /><ProductDetailPage /></>} />
            <Route path="/cart" element={<><Header variant="white" /><CartPage /></>} />
            <Route path="/checkout" element={<><Header variant="white" /><CheckoutPage /></>} />
            <Route path="/success" element={<SuccessPage />} />
          </Routes>
          
          <Footer />
          <ToastContainer position="top-center" />
        </div>
      </CartProvider>
    </Router>
  );
}

export default App;